import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { gameStore, inputValidationStore, manualBetStore } from '../../../../store';
import { handlePlusMinusValue, useAmountValidation } from '../../../../helpers';
import { AutoCashOutSection } from '../../../../components/common/bettingPart';
import { GameResponseTypeName } from '../../../../enums';
import { DoBetSectionWr } from './doBetSection';
import { checkMaxAutoCashOutValue } from '../../../../helpers/checkMaxAutoCashOutValue';

export const DoBetAndAutoCashOutSectionWr = observer(
  ({
    betAmount,
    autoCashOutOdd,
    isAutoCashOut,
    index,
    inputDisable,
    handleOpenNumPad,
    limits,
    isLoaderActive,
    activeFreeBet,
    t,
    i,
  }) => {
    const { minOdd } = gameStore;

    const params = {
      storeValue: autoCashOutOdd,
      minValue: activeFreeBet.minOdd ? activeFreeBet.minOdd : minOdd,
      maxValue: checkMaxAutoCashOutValue(betAmount, limits.maxWin), // todo stegh nael  Worning  ka
      incDec: 0.1,
    };

    useEffect(() => {
      const maxAutoCashOutValue = checkMaxAutoCashOutValue(betAmount, limits.maxWin);
      if (isAutoCashOut && autoCashOutOdd > maxAutoCashOutValue && betAmount <= limits.maxBet) {
        const maxValue = maxAutoCashOutValue > minOdd ? maxAutoCashOutValue : minOdd;
        params.maxValue = maxValue;
        manualBetStore.setAutoCashOutOdd(maxValue, index);
      }
    }, [betAmount, isAutoCashOut]);

    const handleSwitcher = useCallback((e) => {
      e.stopPropagation();
      manualBetStore.autoCashOutToggle(index);
    }, []);

    const handleAutoCashOutOdd = useCallback(
      (action, index) => {
        const changedOddValue = handlePlusMinusValue(action, params);
        manualBetStore.setAutoCashOutOdd(+changedOddValue.toFixed(2), index);
      },
      [autoCashOutOdd, isAutoCashOut, params.maxValue]
    );

    const onChangeAutoCashOut = useCallback((changeValue) => {
      manualBetStore.setAutoCashOutOdd(changeValue, index);
    }, []);

    const { simpleOnChange: onChangeAutoCashOuts } = useAmountValidation(onChangeAutoCashOut);
    const onBlur = (e) => {
      inputValidationStore.setDefaultValue(
        e.target?.value.trim(),
        manualBetStore.setAutoCashOutOdd,
        params,
        index,
        GameResponseTypeName.AutoCashOut
      );
    };
    return (
      <div className='crash-bet-content-wrapper'>
        <AutoCashOutSection
          autoCashOutOdd={autoCashOutOdd}
          isAutoCashOut={isAutoCashOut}
          index={index}
          t={t}
          handleSwitcher={handleSwitcher}
          handleAutoCashOutOdd={handleAutoCashOutOdd}
          onChangeAutoCashOut={onChangeAutoCashOuts}
          onBlur={onBlur}
          inputDisable={inputDisable}
          params={params}
          handleOpenNumPad={handleOpenNumPad}
        />
        <DoBetSectionWr
          activeFreeBet={activeFreeBet}
          betAmount={betAmount}
          index={index}
          isLoaderActive={isLoaderActive}
          i={i}
        />
      </div>
    );
  }
);
